import React from 'react';

import { Checkbox } from '@atlaskit/checkbox';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { FilterButton } from '../filter-button';

const containerStylesOld = xcss({
	paddingLeft: 'space.100',
	paddingRight: 'space.150',
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	boxSizing: 'border-box',
	borderRadius: 'radius.small',
	maxHeight: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
});

const containerStyles = xcss({
	paddingRight: 'space.150',
	boxSizing: 'border-box',
	borderRadius: 'radius.small',
	maxHeight: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
});

const backgroundStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

const containerCheckedStyles = xcss({
	backgroundColor: 'color.background.selected',
});

const labelStyles = xcss({
	fontWeight: token('font.weight.medium'),
	color: 'color.text.subtle',
	maxHeight: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const labelInDropdownStyles = xcss({
	fontWeight: token('font.weight.regular'),
	color: 'color.text.subtle',
	maxHeight: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const labelStylesOld = xcss({
	fontWeight: token('font.weight.medium'),
	maxHeight: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

const labelActiveStyle = xcss({
	color: 'color.text.selected',
});

const checkMarkContainerStyles = xcss({
	display: 'flex',
	gap: 'space.075',
	alignItems: 'center',
});

interface ToggleFilterProps {
	children: string;
	onChange: VoidFunction;
	isChecked: boolean;
	autoFocus: boolean;
	isFilterInDropdown?: boolean;
	isFiltersDiscoverability2Enabled?: boolean;
	iconBefore?: React.JSX.Element;
}

export const ToggleFilter = ({
	children,
	onChange,
	isChecked,
	autoFocus = false,
	isFilterInDropdown = false,
	isFiltersDiscoverability2Enabled,
	iconBefore,
}: ToggleFilterProps) => {
	if (isFiltersDiscoverability2Enabled) {
		return isFilterInDropdown ? (
			<Box xcss={containerStyles}>
				<Checkbox
					label={
						<Box xcss={[labelInDropdownStyles, isChecked && labelActiveStyle]}>{children}</Box>
					}
					onChange={onChange}
					isChecked={isChecked}
					autoFocus={autoFocus}
				/>
			</Box>
		) : (
			<FilterButton
				aria-pressed={isChecked}
				onClick={() => onChange?.()}
				hasChevron={false}
				isSelected={isChecked}
				iconBefore={iconBefore}
			>
				{isChecked && (
					<Box xcss={checkMarkContainerStyles}>
						<CheckMarkIcon
							label="" // Uses the button selected state
						/>
						<Box xcss={[labelStyles, isChecked && labelActiveStyle]}>{children}</Box>
					</Box>
				)}
				{!isChecked && (
					<Checkbox
						label={<Box xcss={[labelStyles, isChecked && labelActiveStyle]}>{children}</Box>}
						onChange={onChange}
						isChecked={isChecked}
						autoFocus={autoFocus}
					/>
				)}
			</FilterButton>
		);
	}

	return (
		<Box
			xcss={[
				containerStylesOld,
				...(!isFilterInDropdown ? [backgroundStyles, isChecked && containerCheckedStyles] : []),
			]}
		>
			<Checkbox
				label={<Box xcss={[labelStylesOld, isChecked && labelActiveStyle]}>{children}</Box>}
				onChange={onChange}
				isChecked={isChecked}
				autoFocus={autoFocus}
			/>
		</Box>
	);
};
